(() => {
  if (window.__pdpImageMagnifierInitialized) return;
  window.__pdpImageMagnifierInitialized = true;

  const ZOOM_LEVEL = 4.5;
  const MOBILE_ZOOM_LEVEL = 8;
  const OPENER_SELECTOR = '.product__modal-opener--image';
  let touchInteraction;
  let suppressNextClick = false;

  function getImage(opener) {
    return opener.querySelector('.product__media img');
  }

  function isZoomIconTarget(opener, event) {
    if (event.target.closest('.product__media-icon')) return true;

    const icon = opener.querySelector('.product__media-icon');
    if (!icon) return false;

    const rect = icon.getBoundingClientRect();
    const hitArea = 12;
    return (
      event.clientX >= rect.left - hitArea &&
      event.clientX <= rect.right + hitArea &&
      event.clientY >= rect.top - hitArea &&
      event.clientY <= rect.bottom + hitArea
    );
  }

  function getLens(opener) {
    let lens = opener.querySelector('.pdp-image-magnifier');
    if (lens) return lens;

    lens = document.createElement('span');
    lens.className = 'pdp-image-magnifier';
    lens.setAttribute('aria-hidden', 'true');
    opener.querySelector('.product__media')?.appendChild(lens);
    return lens;
  }

  function positionLens(opener, clientX, clientY) {
    const image = getImage(opener);
    const media = opener.querySelector('.product__media');
    const lens = getLens(opener);
    if (!image || !media || !lens) return;

    const imageRect = image.getBoundingClientRect();
    const mediaRect = media.getBoundingClientRect();
    if (!imageRect.width || !imageRect.height) return;

    const size = Math.max(112, Math.min(260, Math.min(imageRect.width, imageRect.height) * 0.38));
    const x = Math.max(0, Math.min(clientX - imageRect.left, imageRect.width));
    const y = Math.max(0, Math.min(clientY - imageRect.top, imageRect.height));
    const left = Math.max(0, Math.min(x - size / 2, imageRect.width - size));
    const top = Math.max(0, Math.min(y - size / 2, imageRect.height - size));
    const source = getZoomSource(image);
    const zoomLevel = window.matchMedia('(max-width: 749px)').matches
      ? MOBILE_ZOOM_LEVEL
      : ZOOM_LEVEL;

    lens.style.width = `${size}px`;
    lens.style.height = `${size}px`;
    lens.style.left = `${imageRect.left - mediaRect.left + left}px`;
    lens.style.top = `${imageRect.top - mediaRect.top + top}px`;
    lens.style.backgroundImage = `url("${source}")`;
    lens.style.backgroundSize = `${zoomLevel * 100}% ${zoomLevel * 100}%`;
    lens.style.backgroundPosition = `${(x / imageRect.width) * 100}% ${(y / imageRect.height) * 100}%`;
  }

  // Gallery images use a responsive srcset, so currentSrc may be a small candidate; zoom with the largest
  // candidate up to 1500px (enough for the lens, avoids ~2000px downloads on hover).
  function getZoomSource(image) {
    const srcset = image.getAttribute('srcset');
    if (srcset) {
      let best = null;
      let bestWidth = 0;
      srcset.split(',').forEach((candidate) => {
        const parts = candidate.trim().split(/\s+/);
        const width = parseInt(parts[1], 10) || 0;
        if (parts[0] && width <= 1500 && width >= bestWidth) {
          best = parts[0];
          bestWidth = width;
        }
      });
      if (best) return best;
    }
    return image.currentSrc || image.src;
  }

  function setZoomState(opener, isActive) {
    opener.classList.toggle('is-inline-zoom-active', isActive);
    opener.closest('.product__media-list')?.classList.toggle('is-inline-zoom-active', isActive);
  }

  function closeAll(except) {
    document.querySelectorAll(`${OPENER_SELECTOR}.is-inline-zoom-active`).forEach((opener) => {
      if (opener !== except) setZoomState(opener, false);
    });
  }

  document.addEventListener(
    'pointerdown',
    (event) => {
      if (event.pointerType !== 'touch') return;

      const opener = event.target.closest(OPENER_SELECTOR);
      if (!opener || !getImage(opener)) return;

      const wasActive = opener.classList.contains('is-inline-zoom-active');
      if (!wasActive) return;

      positionLens(opener, event.clientX, event.clientY);
      touchInteraction = {
        cancelled: false,
        opener,
        pointerId: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
        moved: false,
        wasActive,
      };
    },
    true
  );

  document.addEventListener(
    'pointermove',
    (event) => {
      if (!touchInteraction || event.pointerId !== touchInteraction.pointerId) return;

      const deltaX = event.clientX - touchInteraction.startX;
      const deltaY = event.clientY - touchInteraction.startY;
      if (Math.abs(deltaX) > 6 || Math.abs(deltaY) > 6) touchInteraction.moved = true;
      if (!touchInteraction.cancelled) {
        event.preventDefault();
        positionLens(touchInteraction.opener, event.clientX, event.clientY);
      }
    },
    true
  );

  document.addEventListener(
    'touchmove',
    (event) => {
      if (!touchInteraction || touchInteraction.cancelled) return;

      const opener = touchInteraction.opener;
      if (!opener.classList.contains('is-inline-zoom-active')) return;

      const touch = event.touches[0];
      if (!touch) return;

      event.preventDefault();
      positionLens(opener, touch.clientX, touch.clientY);
    },
    { capture: true, passive: false }
  );

  document.addEventListener(
    'pointerup',
    (event) => {
      if (!touchInteraction || event.pointerId !== touchInteraction.pointerId) return;

      const interaction = touchInteraction;
      touchInteraction = undefined;
      if (interaction.cancelled) return;

      if (interaction.wasActive && !interaction.moved && isZoomIconTarget(interaction.opener, event)) {
        setZoomState(interaction.opener, false);
      }
      suppressNextClick = true;
    },
    true
  );

  document.addEventListener(
    'pointercancel',
    (event) => {
      if (touchInteraction && event.pointerId === touchInteraction.pointerId) {
        touchInteraction = undefined;
      }
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      if (suppressNextClick) {
        suppressNextClick = false;
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      const opener = event.target.closest(OPENER_SELECTOR);
      if (!opener) return;

      const image = getImage(opener);
      if (!image) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (
        window.matchMedia('(max-width: 749px)').matches &&
        !isZoomIconTarget(opener, event)
      ) {
        return;
      }

      const isActive = !opener.classList.contains('is-inline-zoom-active');
      setZoomState(opener, isActive);
      if (isActive) {
        closeAll(opener);
        const rect = image.getBoundingClientRect();
        positionLens(opener, rect.left + rect.width / 2, rect.top + rect.height / 2);
      }
    },
    true
  );

  document.addEventListener(
    'pointermove',
    (event) => {
      const opener = event.target.closest(`${OPENER_SELECTOR}.is-inline-zoom-active`);
      if (opener) positionLens(opener, event.clientX, event.clientY);
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      if (!event.target.closest(OPENER_SELECTOR)) closeAll();
    },
    true
  );
})();
